import type { InstructionClause } from '@gonfalon/instructions/instructionTypes/shared';

import type { RuleInstructionKind } from '../rules/constants';

export enum AutomatedReleaseInstructionKind {
  STOP_AUTOMATED_RELEASE = 'stopAutomatedRelease',
}

export type StartAutomatedReleaseSemanticInstruction = {
  kind: RuleInstructionKind.START_AUTOMATED_RELEASE;
  releaseKind: 'guarded' | 'progressive';
  ruleId?: string;
  ref?: string;
  clauses?: InstructionClause[];
  description?: string;
  beforeRuleId?: string;
  originalVariationId: string;
  targetVariationId: string;
  randomizationUnit: string;
  // When `audiences` is set (multi-phase), the top-level `clauses`/`stages` are empty and
  // each phase carries its own clauses and stages on the audience entry instead.
  stages?: Array<{ allocation: number; durationMillis: number }>;
  audiences?: Array<{
    description?: string;
    clauses: InstructionClause[];
    stages: Array<{ allocation: number; durationMillis: number }>;
  }>;
  // Guarded-only fields
  metrics?: Array<{ key: string; isGroup: boolean; metricVersionId?: string; metricGroupId?: string }>;
  metricMonitoringPreferences?: Record<string, { autoRollback: boolean }>;
  // Release-builder cleanup choice. The backend rejects this field on fallthrough
  // releases, so emitters only set it on rule-scoped instructions.
  updateDefaultRuleOnCompletion?: boolean;
};

export type StopAutomatedReleaseSemanticInstruction = {
  kind: AutomatedReleaseInstructionKind.STOP_AUTOMATED_RELEASE;
  ruleId?: string;
  finalVariationId: string;
};

export type AutomatedReleaseSemanticInstruction =
  | StartAutomatedReleaseSemanticInstruction
  | StopAutomatedReleaseSemanticInstruction;
